import CurrentUser from './CurrentUser'

export default class UserPolicy {
  static can (action, user = false) {
    // Get current user
    const currentUser = new CurrentUser()
    const permission = currentUser.users()
    // Evaluate action
    switch (action) {
      // Index
      case 'index':
        return this.canIndex(permission)
      // Read
      case 'read':
        return this.canRead(permission)
      // Update
      case 'edit':
        return this.canEdit(permission)
      // Add
      case 'add':
        return this.canAdd(permission)
      // Remove
      case 'remove':
        return this.canRemove(permission)
      default:
        return false
    }
  }
  static canIndex (permission) {
    return permission !== 'None'
  }
  static canRead (permission) {
    return permission === 'Read' || this.canEdit(permission)
  }
  static canEdit (permission) {
    return permission === 'Edit' || this.canAdd(permission)
  }
  static canAdd (permission) {
    return permission === 'Add' || this.canRemove(permission)
  }
  static canRemove (permission) {
    return permission === 'Remove'
  }
}



// WEBPACK FOOTER //
// ./src/policy/UserPolicy.js